import { render, staticRenderFns } from "./courseware.vue?vue&type=template&id=25a1e378&scoped=true&"
import script from "./courseware.vue?vue&type=script&lang=js&"
export * from "./courseware.vue?vue&type=script&lang=js&"
import style0 from "./courseware.vue?vue&type=style&index=0&id=25a1e378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a1e378",
  null
  
)

export default component.exports